import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'EQUIPMENT';

export default createListReducer(TEMPLATE_NAME);
